module.exports = __webpack_public_path__ + "img/newImage3.3e222232.svg";